import type { Commitment, Contribution, Decision, Snapshot } from './models';
export function commitmentMetrics(items: Commitment[], personId: string) {
  const own = items.filter((c) => c.owner === personId);
  const completed = own.filter((c) => c.status === 'Completed');
  const onTime = completed.filter((c) => c.completedAt && c.completedAt.slice(0, 10) <= c.dueDate);
  return {
    total: own.length,
    completed: completed.length,
    completionRate: own.length ? Math.round((completed.length / own.length) * 100) : null,
    onTime: onTime.length,
  };
}
export function contributionTotals(items: Contribution[], personId: string) {
  const own = items.filter((c) => c.contributor === personId);
  return {
    count: own.length,
    hours: own.filter((c) => c.type === 'Time').reduce((n, c) => n + (c.quantity ?? 0), 0),
    expenseMinor: own
      .filter((c) => c.type === 'Expense paid')
      .reduce((n, c) => n + (c.expenseMinor ?? 0), 0),
  };
}
export function decisionResults(d: Decision) {
  const counts = d.options.map(
    (_, i) =>
      Object.entries(d.votes).filter(([v, n]) => d.participants.includes(v) && n === i).length,
  );
  const total = counts.reduce((a, b) => a + b, 0);
  const max = Math.max(...counts);
  return {
    counts,
    total,
    leaders: total ? d.options.filter((_, i) => counts[i] === max) : [],
    tied: total > 0 && counts.filter((n) => n === max).length > 1,
  };
}
export function trackRecord(s: Snapshot, id: string) {
  return {
    ...commitmentMetrics(s.commitments, id),
    ...contributionTotals(s.contributions, id),
    ventures: s.ventures.filter((v) => v.members.includes(id)),
    mvp: s.ventures.filter(
      (v) => v.members.includes(id) && ['Building MVP', 'Operating'].includes(v.stage),
    ).length,
    endorsements: s.endorsements.filter((e) => e.to === id),
  };
}
